import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import IndexRedirect from 'react-router/lib/IndexRedirect';
import customersRoutes from './main/customers/routes';
import barbersRoutes from './main/barbers/routes';
import EngagementRoutes from './engagement/routes';
import { CampaignBuilderRoutes } from '../modules/shared/engage/campaign-builder/routes';
import ShopWaitingList from './main/waitingList/containers/ShopWaitingList';
import App from './app';
import AppointmentList from './main/appointments/views/list/appointmentsList';
import SideBySideView from './main/appointments/views/sideBySide/containers/SideBySideView';
import CombinedView from './main/appointments/views/combined/combinedView';
import CancelAppointment from './main/appointments/appointmentForm/cancelAppointment';
import EditServiceProvider from './main/services/containers/editServiceProvider';
import ListServicesProvider from './main/services/containers/listServicesProvider';
import ServiceCategoriesRoutes from './main/services/categories/routes';
import ReportsRoutes from './main/reports/routes';
import { ShopProductRoutes } from './products/routes';
import RegisterRoutes from './register/routes';
import SettingsRoutes from './main/settings/routes';
import MembershipsRoutes from './memberships/routes';
import * as hooks from './auth/routerHooks';
import StaffManagementRoutes from './main/staffManagement/routes';
import LoansRoutes from './loans/routes';
import { FS_FEATURES } from '../modules/infra/observability/fullstory';
import { ClientReferralsRoutes } from '../modules/shop/client-referrals/routes';
import PhoneAgentContainer from './main/phoneAgent/phoneAgent';

export default store => (
  <Route path="/" component={App} onEnter={hooks.requireAuthAndRedirect(store)} >
    <IndexRedirect to="/appointments" />
    <Route
      path="/appointments"
      name="appointments"
      onLeave={hooks.resetAppointmentsDate(store)}
      onEnter={hooks.initFullstoryFeature(FS_FEATURES.CALENDAR)}
    >
      <IndexRoute component={SideBySideView} />
      <Route path="list" component={AppointmentList} />
      <Route path="day" component={() => (<CombinedView currentView="agendaDay" />)} />
      <Route path="week" component={() => (<CombinedView currentView="agendaWeek" />)} />
      <Route path="month" component={() => (<CombinedView currentView="month" />)} />
      <Route path=":cancel" name="appointment.cancel" component={CancelAppointment} />
    </Route>

    <Route path="/waiting-list" onEnter={hooks.requireWaitingListViewPermission(store)} component={ShopWaitingList} />

    {customersRoutes.ShopRoutes(store)}
    {barbersRoutes.ShopRoutes(store)}
    {StaffManagementRoutes(store)}

    <Route path="/services" name="services" onEnter={hooks.requireServiceViewPermission(store)}>
      <IndexRoute component={ListServicesProvider} />
      <Route
        path="categories"
        onEnter={hooks.requireServiceModifyPermission(store)}
      >
        {ServiceCategoriesRoutes()}
      </Route>
      <Route
        path="add"
        name="services.add"
        component={EditServiceProvider}
        onEnter={hooks.requireServiceAddPermission(store)}
      />
      <Route
        path=":serviceId"
        name="services.details"
        component={EditServiceProvider}
        onEnter={hooks.requireServiceModifyPermission(store)}
      />
      <Route
        path=":serviceId/assign"
        name="services.assign"
        component={EditServiceProvider}
        onEnter={hooks.requireServiceModifyPermission(store)}
      />
    </Route>

    {ReportsRoutes.ShopRoutes(store)}
    {SettingsRoutes.ShopRoutes(store)}

    {ShopProductRoutes(store)}
    {RegisterRoutes(store)}
    {EngagementRoutes(store)}
    {CampaignBuilderRoutes(store)}
    {MembershipsRoutes.ShopRoutes(store)}
    {LoansRoutes(store)}
    {ClientReferralsRoutes()}
    
    <Route path="/phone-agent" component={PhoneAgentContainer} onEnter={hooks.requirePhoneAgentPermission(store)} />
  </Route>
);
